import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { userReducer } from './user.reducer';
import { featureKey } from './index';

@NgModule({
  imports: [
    StoreModule.forFeature(featureKey, userReducer)
  ]
})
export class UserStoreModule {}
